import PostApi from "../api/PostApi";

export const notifyPublishSuccess = post => {
  let successImageUrls = [
    "http://s2.quickmeme.com/img/a1/a1114dde8c89743b6aa795c7723104d7ade269d3632b318ed4bd29711b5e9f84.jpg",
    "http://i0.kym-cdn.com/entries/icons/original/000/000/745/success.jpg",
  ];
  return PostApi.getNotifyUrl({
    attachments: [
      {
        text: `A publish was successful \n ${JSON.stringify(post, null, 2)}`,
        image_url: successImageUrls[Math.floor(Math.random() * successImageUrls.length)],
      },
    ],
  });
};

export const notifyPublishFailure = post => {
  let failureImageUrls = [
    "https://pbs.twimg.com/profile_images/758477151880351745/qoij-S2c_400x400.jpg",
    "http://68.media.tumblr.com/3e528bed842dca00f9a49ebdf59cd3ec/tumblr_inline_of5w82suZ11tn0tli_500.png",
    "https://i.pinimg.com/736x/56/80/a3/5680a32ff670608ba0526c2ca7627c9f--funny-tweets-reaction-pictures.jpg",
    "http://www.troll.me/images/upset-pikachu/upset-pikachu.jpg",
  ];
  return PostApi.getNotifyUrl({
    attachments: [
      {
        text: `A publish has failed \n ${JSON.stringify(post, null, 2)}`,
        image_url: failureImageUrls[Math.floor(Math.random() * failureImageUrls.length)],
      },
    ],
  });
};



// WEBPACK FOOTER //
// ./src/services/slack.js